import './playlistCard.scss'
import { useAppDispatch } from '@/app/hooks';
import { fetchPlaylistById, playlistByIdBeezer } from '@/features/playlist/playlistSlice';
import { IPlaylistCardProps } from '@/interface'
import { useNavigate } from 'react-router-dom';
import { Picture } from '@deyvis17gy/atom-img'
import loader from '@/assets/img/Spinning.gif'

export const PlayListCard = ({ playlists, isGuest }: IPlaylistCardProps) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const goPlaylistId = (id: string) => {
        if (isGuest) {
            dispatch(playlistByIdBeezer(id))
            navigate(`/playlist/${id}`)
            return
        }
        dispatch(fetchPlaylistById(id))
        navigate(`/playlist/${id}`)
    }

    return (
        <>
            {playlists && playlists?.map(playlist => (
                <figure className='m-playListCard' onClick={() => goPlaylistId(playlist.id)} key={playlist.id}>
                    {/* <img loading='lazy' className='m-playListCard__img' src={playlist.images[0].url} alt={playlist.name} /> */}
                    <Picture loaderUrl={loader} url={playlist.images[0].url} classPicture='m-playListCard__img' alt={playlist.name} />
                </figure>

            ))}
        </>
    )
}
